// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1eSMF","productName":"Table_productName__1mJbt"};